(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[786],{

/***/ 583:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vote",
      function () {
        return __webpack_require__(7194);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ participants; }
/* harmony export */ });
var knut = {
    twitchId: 43494917,
    name: "Knut",
    url: "https://www.twitch.tv/knut",
    twitchName: "knut"
};
var wakewilder = {
    twitchId: 526832402,
    name: "WakeWilder",
    url: "https://www.twitch.tv/wakewilder",
    twitchName: "wakewilder"
};
var participants = [
    {
        category: "trainers",
        members: [
            knut,
            wakewilder
        ]
    },
    {
        category: "streamers",
        members: [
            {
                twitchId: 94753024,
                name: "Mizkif",
                url: "https://www.twitch.tv/mizkif",
                twitchName: "mizkif"
            },
            {
                twitchId: 21841789,
                name: "Nmplol",
                url: "https://www.twitch.tv/Nmplol",
                twitchName: "nmplol"
            },
            {
                twitchId: 37522866,
                name: "Cyr",
                url: "https://twitch.tv/cyr",
                twitchName: "cyr"
            },
            {
                twitchId: 127463427,
                name: "RichWCampbell",
                url: "https://www.twitch.tv/richwcampbell",
                twitchName: "richwcampbell"
            },
            {
                twitchId: 27717340,
                name: "Tectone",
                url: "https://www.twitch.tv/tectone",
                twitchName: "tectone"
            },
            {
                twitchId: 96858382,
                name: "Erobb221",
                url: "https://www.twitch.tv/erobb221",
                twitchName: "erobb221"
            },
            {
                twitchId: 38746172,
                name: "EsfandTV",
                url: "https://www.twitch.tv/esfandtv",
                twitchName: "esfandtv"
            },
            {
                twitchId: 29400754,
                name: "Lacari",
                url: "https://www.twitch.tv/Lacari",
                twitchName: "lacari"
            }, 
        ]
    },
    {
        category: "chefs",
        members: [
            {
                twitchId: 68090599,
                name: "Exxzy",
                url: "https://www.twitch.tv/exxzy",
                twitchName: "exxzy"
            }, 
        ]
    },
    {
        category: "guests",
        members: [
            {
                twitchId: 26194208,
                name: "MitchJones",
                url: "https://www.twitch.tv/mitchjones",
                twitchName: "mitchjones"
            },
            {
                twitchId: 32491081,
                name: "Malena",
                url: "https://www.twitch.tv/malena",
                twitchName: "malena"
            },
            {
                twitchId: 192133946,
                name: "Jeanette",
                url: "https://www.twitch.tv/jeanetteiswatching",
                twitchName: "jeanetteiswatching"
            },
            {
                twitchId: 503310135,
                name: "HafthorJulius",
                url: "https://www.twitch.tv/hafthorjulius",
                twitchName: "hafthorjulius"
            },
            {
                twitchId: 31069476,
                name: "dCapio",
                url: "https://www.twitch.tv/dcapio",
                twitchName: "dcapio"
            }, 
        ]
    },
    {
        category: "judges",
        members: [
            knut,
            wakewilder,
            {
                twitchId: 32491081,
                name: "Malena",
                url: "https://www.twitch.tv/malena",
                twitchName: "malena"
            },
            {
                twitchId: 26261471,
                name: "Asmongold",
                url: "https://www.twitch.tv/asmongold",
                twitchName: "asmongold"
            }, 
        ]
    }, 
];


/***/ }),

/***/ 7194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Vote; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(9452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(8975);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(3712);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.3_65aaefrptgalbi6a2fwpzxfmae/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(8423);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.3_65aaefrptgalbi6a2fwpzxfmae/node_modules/next/image.js
var next_image = __webpack_require__(7659);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(959);
// EXTERNAL MODULE: ./components/layout/PageLayout.tsx + 4 modules
var PageLayout = __webpack_require__(2582);
// EXTERNAL MODULE: ./content/links.ts
var links = __webpack_require__(2304);
// EXTERNAL MODULE: ./content/streamers.ts
var streamers = __webpack_require__(1167);
// EXTERNAL MODULE: ./content/text.ts
var content_text = __webpack_require__(9862);
// EXTERNAL MODULE: ./node_modules/.pnpm/@supabase+supabase-js@1.35.6/node_modules/@supabase/supabase-js/dist/module/index.js + 43 modules
var dist_module = __webpack_require__(2233);
;// CONCATENATED MODULE: ./utils/supabaseClient.ts




var VOTES_TABLE = "votes";
var supabase = (0,dist_module/* createClient */.eI)("https://fyakyvlpknktewidqyct.supabase.co" || 0, "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZ5YWt5dmxwa25rdGV3aWRxeWN0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2NTk5MzQ0MDMsImV4cCI6MTk3NTUxMDQwM30.luPUQC2BU0mJ6xEJsO9Uh1pP5-kMDTi_X03_AXY--b0" || 0);
var signInTwitch = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var redirectTo, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    redirectTo = _args.length > 0 && _args[0] !== void 0 ? _args[0] : "".concat(links/* baseUrl */.FH, "/vote");
                    _ctx.next = 3;
                    return supabase.auth.signIn({
                        provider: "twitch"
                    }, {
                        redirectTo: redirectTo
                    });
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function signInTwitch() {
        return _ref.apply(this, arguments);
    };
}();
var signOutTwitch = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return supabase.auth.signOut();
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function signOutTwitch() {
        return _ref.apply(this, arguments);
    };
}();
// TODO: handle errors
var getUsersVote = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(userId) {
        var ref, data, error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return supabase.from(VOTES_TABLE).select("vote").filter("user_id", "eq", userId);
                case 2:
                    ref = _ctx.sent;
                    data = ref.data;
                    error = ref.error;
                    return _ctx.abrupt("return", data);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getUsersVote(userId) {
        return _ref.apply(this, arguments);
    };
}();
// TODO: handle errors
var updateVoteForUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(userId, vote) {
        var ref, data, error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return supabase.from(VOTES_TABLE).update({
                        vote: vote
                    }).eq("user_id", userId);
                case 2:
                    ref = _ctx.sent;
                    data = ref.data;
                    error = ref.error;
                    return _ctx.abrupt("return", data);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateVoteForUser(userId, vote) {
        return _ref.apply(this, arguments);
    };
}();
// TODO: handle errors
var insertVoteForUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(userId, vote) {
        var ref, data, error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return supabase.from(VOTES_TABLE).insert({
                        user_id: userId,
                        vote: vote
                    }, {
                        returning: "minimal"
                    });
                case 2:
                    ref = _ctx.sent;
                    data = ref.data;
                    error = ref.error;
                    return _ctx.abrupt("return", data);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function insertVoteForUser(userId, vote) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var supabaseClient = ((/* unused pure expression or super */ null && (supabase)));

// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(5924);
;// CONCATENATED MODULE: ./pages/vote/index.tsx













var ref;
var vote_streamers = (ref = streamers/* participants.find */.U.find(function(e) {
    return e.category === "streamers";
})) === null || ref === void 0 ? void 0 : ref.members;
function Vote() {
    var ref;
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(null), user = ref2[0], setUser = ref2[1];
    var ref3 = (0,react.useState)(null), vote = ref3[0], setVote = ref3[1];
    var ref4 = (0,react.useState)(), previousVote = ref4[0], setPreviousVote = ref4[1];
    var ref5 = (0,react.useState)(false), hasVoted = ref5[0], setHasVoted = ref5[1];
    var submitVote = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(!user || !vote)) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    setPreviousVote(vote);
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                    if (!hasVoted) {
                        _ctx.next = 7;
                        break;
                    }
                    // TODO: handle errors
                    updateVoteForUser(user.id, vote);
                    return _ctx.abrupt("return");
                case 7:
                    _ctx.next = 9;
                    return insertVoteForUser(user.id, vote);
                case 9:
                    data = _ctx.sent;
                    setHasVoted(true);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        vote,
        user,
        hasVoted
    ]);
    var hasUserVoted = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(userId) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getUsersVote(userId);
                    case 2:
                        data = _ctx.sent;
                        setHasVoted(!!(data === null || data === void 0 ? void 0 : data.length));
                        if (data === null || data === void 0 ? void 0 : data.length) {
                            setVote(data[0].vote);
                            setPreviousVote(data[0].vote);
                        }
                        setIsLoading(false);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(userId) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    (0,react.useEffect)(function() {
        var session = supabase.auth.session();
        var ref;
        var user = (ref = session === null || session === void 0 ? void 0 : session.user) !== null && ref !== void 0 ? ref : null;
        setUser(user);
        if (user) {
            hasUserVoted(user.id);
        } else {
            setIsLoading(false);
        }
        var ref1 = supabase.auth.onAuthStateChange(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event, session) {
                var ref, newUser;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            newUser = (ref = session === null || session === void 0 ? void 0 : session.user) !== null && ref !== void 0 ? ref : null;
                            if (!newUser) {
                                _ctx.next = 7;
                                break;
                            }
                            setIsLoading(true);
                            setUser(newUser);
                            hasUserVoted(newUser.id);
                            return _ctx.abrupt("return");
                        case 7:
                            setUser(null);
                            setVote(null);
                        case 9:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(event, session) {
                return _ref.apply(this, arguments);
            };
        }()), listener = ref1.data;
        return function() {
            listener === null || listener === void 0 ? void 0 : listener.unsubscribe();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var og = {
        site_name: content_text/* seo.title */.$K.title,
        title: "Vote - " + content_text/* seo.title */.$K.title,
        description: "Vote for the streamer you think has performed the best at Camp Knut",
        url: links/* baseUrl */.FH + "/vote"
    };
    var Streamer = function(streamer) {
        var twitchName = streamer.twitchName, name = streamer.name;
        var selected = vote === twitchName;
        var _obj;
        var wrapperClassName = (0,clsx_m/* default */.Z)("rounded-xl p-3 text-center transition duration-300", (_obj = {}, (0,_define_property/* default */.Z)(_obj, "bg-knut-light-bg-info dark:bg-knut-dark-bg-info", !selected), (0,_define_property/* default */.Z)(_obj, "bg-knut-dark-bg-info dark:bg-knut-light-bg-info", selected), _obj));
        var Text = function() {
            var _obj;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (0,clsx_m/* default */.Z)("text-2xl pb-2 font-black", (_obj = {}, (0,_define_property/* default */.Z)(_obj, "text-black dark:text-white", !selected), (0,_define_property/* default */.Z)(_obj, "text-white dark:text-black", selected), _obj)),
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "container mx-auto flex justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/participants/".concat(twitchName, ".webp"),
                            className: "mx-auto rounded-md",
                            height: 250,
                            width: 250,
                            objectFit: "cover",
                            alt: name
                        })
                    })
                ]
            });
        };
        if (!user) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: wrapperClassName,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {})
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            type: "button",
            onClick: function() {
                return setVote(twitchName);
            },
            className: wrapperClassName,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {})
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout/* default */.Z, {
        openGraph: og,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            children: [
                isLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    role: "status",
                    className: "mx-auto h-14 w-14",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            "aria-hidden": "true",
                            className: "mr-2 h-full w-full animate-spin fill-blue-600 text-gray-200 dark:text-gray-600",
                            viewBox: "0 0 100 101",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                                    fill: "currentColor"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                                    fill: "currentFill"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sr-only",
                            children: "Loading..."
                        })
                    ]
                }),
                !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                            className: "text-3xl mt-5 mb-4 mr-4 text-center font-black text-knut-light-header dark:text-knut-dark-header",
                            children: [
                                "Who do you think will perform the best",
                                user ? ", ".concat(user.user_metadata.nickname) : "",
                                user && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "ml-4 inline-flex items-center justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: user === null || user === void 0 ? void 0 : user.user_metadata.picture,
                                        alt: "Camp Knut",
                                        width: 64,
                                        height: 64,
                                        priority: true,
                                        decoding: "async",
                                        className: "inline-block aspect-auto"
                                    })
                                })
                            ]
                        }),
                        !user && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-center",
                            children: "You need to login to vote"
                        }),
                        user && hasVoted && /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            className: "text-center",
                            children: [
                                "You have voted for",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: (ref = vote_streamers === null || vote_streamers === void 0 ? void 0 : vote_streamers.find(function(s) {
                                            return s.twitchName === previousVote;
                                        })) === null || ref === void 0 ? void 0 : ref.name
                                    })
                                }),
                                ". You can change your vote below."
                            ]
                        }),
                        user ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-5 mb-4 mr-4 text-center font-bold",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    return signOutTwitch();
                                },
                                className: "text-2xl rounded-xl bg-knut-other-twitch p-2.5 text-center text-knut-dark-header",
                                children: "Sign Out"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-3xl mt-5 mb-4 mr-4 text-center font-bold",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    return signInTwitch();
                                },
                                className: "text-2xl rounded-xl bg-knut-other-twitch p-2.5 text-center text-knut-dark-header",
                                children: "Sign in"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid grid-cols-1 gap-6 p-6 md:grid-cols-2 lg:grid-cols-3",
                            children: vote_streamers === null || vote_streamers === void 0 ? void 0 : vote_streamers.map(function(props) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Streamer, (0,_object_spread/* default */.Z)({}, props), props.name);
                            })
                        }),
                        user && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: submitVote,
                                className: (0,clsx_m/* default */.Z)(" rounded py-3 px-6 font-bold", {
                                    "cursor-not-allowed bg-gray-300 text-gray-500": !!!vote,
                                    "bg-knut-dark-tag text-white": !!vote
                                }),
                                disabled: !!!vote,
                                children: "Vote"
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [154,555,166,131,774,888,179], function() { return __webpack_exec__(583); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);